import { SET_PAGE } from './types';

/**
 * @param {number} pageNumber
 * @returns {Object} action
 * @returns {string} action.type - SET_PAGE
 * @returns {number} action.payload - pageNumber
 */
export const setPage = (pageNumber) => {
	return {
		type: SET_PAGE,
		payload: pageNumber
	};
};
